import { Component, OnInit, Input } from '@angular/core';
import { DadosService } from '../../db/dados.service';


@Component({
  selector: 'app-enviar-pedido',
  templateUrl: './enviar-pedido.component.html',
  styleUrls: ['./enviar-pedido.component.scss']
})
export class EnviarPedidoComponent implements OnInit {

  constructor(private dados: DadosService) { }

  ngOnInit() {
  }

  confirmarPedido() {
    this.dados.confirmarPedido(
      r=>{ 
        this.dados.goto('/menu');
      }
    );
    return true;
  }

  @Input()
  get total() {
    return this.dados.total;
  }



  @Input()
  get carrinho() {
    return this.dados.carrinho;
  }


}
